import { defineMessages } from 'react-intl';

export default defineMessages({
  navigateAlert: {
    id: 'quoteQuestions.navigateAlert',
    defaultMessage: "Are you sure you want to leave this page? Your answers won't be saved.",
  },
});
